<template>
  <div class="whiteBg">
    <div class="container row2">
      <div class="text">
        <h2 class="font-weight-bold">
          자동 리뷰 검수 기능을 통한<br />
          퀄리티 높은 컨텐츠
        </h2>
        <p class="font-weight-light">
          슈퍼멤버스는 자동 리뷰 검수 기능으로<br />
          글자수, 사진 수, 키워드 포함 여부, 구매링크 체크를 통해<br />
          더욱 높은 퀄리티 컨텐츠를 제공합니다.
        </p>
      </div>
      <img :src="image" class="row-image mx-2" />
    </div>
  </div>
</template>

<script>
import userMixin from '@/components/shared/userMixin';

export default {
  name: 'InspectionReview',
  mixins: [userMixin],
  data() {
    return {
      image:
        window.innerWidth > 960
          ? require('@/assets/img/landing/ceo-landing/auto-check.png')
          : require('@/assets/img/landing/ceo-landing/auto-check-mobile.png'),
    };
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.image =
        window.innerWidth > 960
          ? require('@/assets/img/landing/ceo-landing/auto-check.png')
          : require('@/assets/img/landing/ceo-landing/auto-check-mobile.png');
    });
  },
};
</script>

<style scoped lang="scss">
.row2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 72px 0;
  @media (max-width: 960px) {
    padding: 80px 0px 56px;
    overflow: hidden;
  }
}
.row2 .row-image {
  width: 707px;
  margin: 12px 0 0 0;
  @media (max-width: 960px) {
    max-width: 400px;
    margin: 16px auto;
    width: 100%;
    text-align: center;
  }
}

.text {
  .eyebrow {
    color: #757575;
    margin-bottom: 4px;
    margin-left: 1px;
    font-size: 14px;
  }
  h2 {
    margin-bottom: 12px;
    color: #212121;
  }
  p {
    color: #484848;
    line-height: 1.8;
  }
  @media (max-width: 960px) {
    // padding-top: 0;
    // margin-bottom: auto;
    .eyebrow {
      margin-bottom: 6px;
      font-size: 13px;
    }
    h2 {
      margin-bottom: 12px;
    }
    p {
      color: #484848;
      line-height: 1.94;
    }
  }
}

.rank-button {
  background: #ffffff;
  border: 2px solid #bd1328;
  border-radius: 16px;
  color: #bd1328;
  font-size: 14px;
}

.whiteBg {
  background-color: #fff;
}
</style>
